import styled from 'styled-components';
import { spaces } from '../../../../shared/lib/styles';
import { between, only } from '../../../../shared/spa/core-components/utils/media';
import { CategoryHeroConfig } from '../CategoryConfigProvider';
import HeroDesignCard from './HeroDesignCard';
import LaptopHeroImage from './LaptopHeroImage';

const Wrapper = styled.div`
    position: relative;
    white-space: nowrap;

    ${between('small', 'medium')} {
        padding-top: ${spaces.space10}px;
        padding-bottom: ${spaces.space11}px;
        text-align: center;
        overflow: scroll;
    }

    ${only('small')} {
        padding-left: ${spaces.halfGutter}px;
        padding-right: ${spaces.halfGutter}px;
    }

    ${only('medium')} {
        padding-left: ${spaces.gutter}px;
        padding-right: ${spaces.gutter}px;
    }

    ${between('normal', 'large')} {
        position: absolute;
        top: 300px;
        left: 50%;
        transform: translate(-50%);
        width: 20px;
        height: 20px;
        margin-left: auto;
        margin-right: auto;
    }
`;

interface Props {
    hero: CategoryHeroConfig;
    categoryTitle: string;
    isHeroView: boolean;
}

const FeaturedDesigns = ({ hero, categoryTitle, isHeroView }: Props) => (
    <div>
        {hero.heroImage && (
            <LaptopHeroImage
                src={hero.heroImage.src}
                altText={hero.heroImage.altText}
                designer={hero.heroImage.designer}
            />
        )}
        <Wrapper>
            {hero.images.map((image, index) => (
                <HeroDesignCard
                    key={index}
                    index={index}
                    isHeroView={isHeroView}
                    hasFeatureImage={!!hero.heroImage}
                    image={image}
                    categoryTitle={categoryTitle}
                />
            ))}
        </Wrapper>
    </div>
);

export default FeaturedDesigns;
